const texts = document.querySelectorAll('.text-animation')

const observer_options = {
  text: {},
  header: {}
}
const observer_text = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-show')
    }
  })
}, observer_options.text)


texts.forEach(text => {
  observer_text.observe(text)
})

window.addEventListener('DOMContentLoaded', () => {
  const overseas = document.getElementsByClassName('js-overseas')[0]
  const selectBox = document.getElementsByClassName('js-prefecture_id')[0]

  function updateSelectBox() {
    if (overseas.checked) {
      selectBox.disabled = true
    } else {
      selectBox.disabled = false
    }
  }

  updateSelectBox()
  if (overseas) {
    overseas.addEventListener('change', updateSelectBox) // チェックボックスの変更を監視
  }
})
